module.exports = __webpack_public_path__ + "static/1-f2ad2da8ccd927591323d340447399a5.jpeg";